module.exports = __webpack_public_path__ + "assets/img/desc-03-0159d522.png";